// extracted by mini-css-extract-plugin
export var area = "recommenditemscard-module--area--c3d35";
export var cardLink = "recommenditemscard-module--cardLink--f63c8";
export var cardWrapper = "recommenditemscard-module--cardWrapper--eabde";
export var contentSide = "recommenditemscard-module--contentSide--c8bca";
export var description = "recommenditemscard-module--description--771c8";
export var eyecatch = "recommenditemscard-module--eyecatch--4cbdd";
export var imageSide = "recommenditemscard-module--imageSide--64870";
export var label = "recommenditemscard-module--label--7fb5c";
export var meta = "recommenditemscard-module--meta--a5220";
export var motoIcon = "recommenditemscard-module--motoIcon--3c486";
export var slimCard = "recommenditemscard-module--slimCard--081f0";
export var slimLabelBadge = "recommenditemscard-module--slimLabelBadge--dfb1d";
export var time = "recommenditemscard-module--time--e359f";
export var title = "recommenditemscard-module--title--c9a6b";